// src/components/Footer.js
const Footer = () => (
  <footer>
    <p>© 2025 My App. All rights reserved.</p>
  </footer>
);
export default Footer;
